import { formatRecommendedQty } from '@/lib/recommendation';

interface Props {
  qty: number;
  severity: string;
}

export default function RecommendedQtyCell({ qty, severity }: Props) {
  const rec = formatRecommendedQty(qty, severity);
  return <span title={rec.title}>{rec.text}</span>;
}
